import Program_listsModel from '../Apis/Program_lists'
import Controller from './Controller'

export default class Program_listsController extends Controller {
  constructor() {
    super(new Program_listsModel())
  }
  
}
